import * as Yup from 'yup';

const message: string = 'You have to agree to the Terms and Conditions and Privacy Policy in order to use Zencargo.';

export const termsAndConditionValidation = Yup.boolean().required(message).oneOf([true], message);
